
namespace TabAurous.Purchase {
    /*
    export class ChartPanelOptions {
        items: ApprovalInRow[];
    }

    export class ChartPanel extends Serenity.TemplatedPanel<ChartPanelOptions> {
        constructor(container: JQuery, opt: ChartPanelOptions) {
            super(container, opt);

            //Grouping
            var data = this.options.items;
            var code = [""];
            var grossamount = [0];
            code.pop();
            grossamount.pop();
            for (var i = 0; i < data.length; i++) {
                var checkexists = false;
                for (var j = 0; j < code.length; j++) {
                    if (data[i].LedgerName.match(code[j])) {
                        checkexists = true;
                        grossamount[j] += data[i].GrossAmount;
                    }
                }
                if (!checkexists) {
                    code.push(data[i].LedgerName); 
                    grossamount.push(data[i].GrossAmount);
                }
            }
            var options = {
                chart: {
                    height: 250,
                    width:430,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                series: [
                    {
                        name: 'sales',
                        data: grossamount
                    }
                    ],

                    stroke: {
                        curve: 'straight'
                    },
                xaxis: {
                    categories: code
                }
            }
            //var x = document.getElementById('TabAurous_Purchase_ChartPanel11_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);
            chart.render();
        }

        getTemplate() {
            
            return `<div id="~_chartContainer"></div>`;
        }
    }
    */
    @Serenity.Decorators.registerClass()
    export class ApprovalInGrid extends _Ext.GridBase<ApprovalInRow, any> {
        protected getColumnsKey() { return 'Purchase.ApprovalIn'; }
        protected getDialogType() { return ApprovalInDialog; }
        protected getIdProperty() { return ApprovalInRow.idProperty; }
        protected getInsertPermission() { return ApprovalInRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInRow.localTextPrefix; }
        protected getService() { return ApprovalInService.baseUrl; }
        //private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        //private chartContainer: JQuery;
        //private chartPanel: ChartPanel;
        constructor(container: JQuery) {
            super(container);

            this.addDateRangeFilter("TransDate", "Date");
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(31);
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[31].AutoPosting;
            this.editItem(<ApprovalInRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                VoucherTypeId: 31,
                TaxAmount: 0,
                BaseItemTypeId: 0,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }
        /*
        onViewProcessData(response: Serenity.ListResponse<ApprovalInRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new ChartPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();
            

            return response;
        }
        */

        protected getButtons(): Serenity.ToolButton[] {
            var btn = super.getButtons();

            btn.push({
                title: 'Import Approval Out',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    if (!this.onViewSubmit()) {
                        return;
                    }

                    let transids;
                    ApprovalInService.PostedTransIdList({}, response => { transids = response.Entities }, { async: false });
                    var _transids = transids.map(x => x.RefTransId);
                    var dialog = new Common.VoucherPostingDialog();
                    dialog.transids = _transids;
                    dialog.vouchertypeid = 32;
                    dialog.element.height(500);
                    dialog.element.width(500);
                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {
                            if (dialog.vouchernos.length > 0) {
                                var partyid = parseInt(dialog.form.PartyId.value);
                                ApprovalInService.APIImportApprovals({ Entities: dialog.vouchernos, PartyId: partyid }, response => {
                                    if (response.Error == null) {
                                        Q.postToService({
                                            service: Common.ExcelImportService.baseUrl + '/APIImportResponseExportExcel',
                                            request: {
                                                VouchersCompleted: response.VouchersCompleted,
                                                VoucherswithIssues: response.VoucherswithIssues
                                            },

                                            target: '_blank'
                                        });
                                        this.refresh()
                                    }
                                }, { async: false });
                            }
                        }
                    });

                    //var pickerDialog = new _Ext.GridItemPickerDialog({
                    //    gridType: grid, multiple: true
                    //});
                    ////pickerDialog.onSuccess = (selectedItems: POSOrderRow[]) => {
                    ////    let selectedItems2 = selectedItems;
                    ////    for (var i = 0; i < selectedItems2.length; i++) {
                    ////        var order = selectedItems2[i];
                    ////        order.TransId = null;
                    ////        order.NetAmount = order.NetAmount == undefined ? 0 : order.NetAmount;
                    ////        order.GrossAmount = order.GrossAmount == undefined ? 0 : order.GrossAmount;
                    ////        order.ItemDetails = ItemGridHelper.SetSalesOrderGrid(order.ItemDetails, new Date(order.TransDate), 0, 1, 0, 0, 0);

                    ////        POSOrderService.Create({ Entity: order }, () => { }, { async: false });

                    ////        this.refresh();
                    ////    }

                    ////}
                    //pickerDialog.dialogOpen();
                }
            });
            return btn;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}